<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";

export default {
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      title: "Master Dashboard Preview",
      iframeLink: null,
    };
  },

  async mounted() {
    await this.getData();
  },

  methods: {
    getData() {
      let id = this.$route.params.id;

      axios({
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/dashboard/preview",
        method: "get",
        params: {
          id: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((res) => {
        let meta = res?.data?.meta;

        if (meta?.code == 200) {
          let resData = res?.data?.data;
          this.iframeLink = resData.link_dashboard;
        }
      });
    },

    reloadIframe() {
      const iframe = this.$refs.dashboardIframe;

      if (iframe) {
        iframe.src = "";
        
        this.$nextTick(() => {
          iframe.src = this.iframeLink;
        });
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <!-- Reload Button -->
            <button
              class="btn btn-primary mb-3"
              @click="reloadIframe"
            >
              Reload Iframe
            </button>

            <!-- Iframe -->
            <iframe
              v-if="iframeLink"
              ref="dashboardIframe"
              :src="iframeLink"
              width="100%"
              height="800"
              frameborder="0"
            ></iframe>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>